import React, { createContext, useContext } from 'react'

export const DEFAULT_LOCALE = 'vi'
export const SUPPORTED_LOCALES = ['vi', 'en', 'zh-CN']
export const LOCALE_STORAGE_KEY = 'brick-game-locale'

const messages = {
  vi: {
    'locale.vi': 'Tiếng Việt', 'locale.en': 'English', 'locale.zh-CN': '简体中文',
    'app.brandKicker': 'MÁY CHƠI GAME CẦM TAY',
    'app.brandTagline': 'Sáu trò chơi kinh điển. Một chiếc máy.',
    'app.nowPlaying': 'ĐANG CHƠI', 'app.language': 'Ngôn ngữ', 'app.topTenButton': '🏆 Top 10',
    'app.hideGuide': 'Ẩn hướng dẫn', 'app.showGuide': 'Hiện hướng dẫn',
    'app.switchToArrows': 'Dùng mũi tên', 'app.switchToWasd': 'Dùng WASD',
    'app.wasdMovement': 'Di chuyển bằng WASD',
    'app.movementAria': 'Hướng dẫn phím di chuyển', 'app.actionAria': 'Hướng dẫn phím hành động và hệ thống',
    'app.desktopControls1': 'PHÍM DESKTOP / 01', 'app.desktopControls2': 'PHÍM DESKTOP / 02',
    'app.moveSelect': 'Di chuyển & chọn', 'app.actionSystem': 'Hành động & hệ thống',
    'app.arrowKeys': 'Các phím mũi tên', 'app.wasdKeys': 'Các phím WASD',
    'app.wasdMoveHelp': 'WASD dùng để di chuyển hoặc lái khi chơi. Trong menu, A/D chỉnh tốc độ và W/S chỉnh cấp độ.',
    'app.arrowMoveHelp': 'Phím mũi tên dùng để di chuyển hoặc lái khi chơi. Trong menu, ←/→ chỉnh tốc độ và ↑/↓ chỉnh cấp độ.',
    'app.actionHelp': 'Hành động / bắn / xoay*', 'app.actionFireRotate': 'Hành động / bắn / xoay*', 'app.startPause': 'Bắt đầu / tạm dừng',
    'app.reset': 'Chơi lại', 'app.sound': 'Âm thanh',
    'app.space': 'Space', 'app.spaceHelp': 'Space hoặc X chọn trò tiếp theo trong menu và kích hoạt nút XOAY lớn khi chơi, dù nút khác đang được chọn. Dùng Enter để mở nút thanh công cụ. *Hành động dùng trong Xếp hình, Xe tăng và Bắn súng.',
    'app.actionHint': 'Space hoặc X chọn trò tiếp theo trong menu và kích hoạt nút XOAY lớn khi chơi, dù nút khác đang được chọn. Dùng Enter để mở nút thanh công cụ. *Hành động dùng trong Xếp hình, Xe tăng và Bắn súng.',
    'app.topTenTitle': 'Bảng xếp hạng Top 10', 'app.closeLeaderboard': 'Đóng bảng xếp hạng',
    'app.mobileGuideButton': 'Hướng dẫn', 'app.mobileGuideTitle': 'Hướng dẫn chơi', 'app.closeGuide': 'Đóng hướng dẫn',
    'app.mobileGuideMove': 'Dùng các nút hướng trên máy để di chuyển. Trong menu, trái/phải chỉnh tốc độ và lên/xuống chỉnh cấp độ.',
    'app.mobileGuideAction': 'XOAY để hành động, bắn hoặc xoay; CHƠI để bắt đầu hoặc tạm dừng; LẠI để chơi lại; ÂM để bật/tắt âm thanh.',
    'app.mobileGuideGames': 'Ở màn hình chào, bấm XOAY để chuyển trò chơi.',
    'app.mobileGuideDifficulty': 'Độ khó tăng tự động theo điểm. CẤP và TỐC ĐỘ trên LCD cho biết mức hiện tại.',
    'app.machineAria': 'Máy chơi Brick Game',
    'game.tetris': 'XẾP HÌNH', 'game.snake': 'RẮN SĂN MỒI', 'game.shooting': 'BẮN SÚNG',
    'game.racing': 'ĐUA XE', 'game.breakout': 'PHÁ GẠCH', 'game.tank': 'XE TĂNG',
    'device.highScore': 'KỶ LỤC', 'device.score': 'ĐIỂM', 'device.level': 'CẤP', 'device.speed': 'TỐC ĐỘ', 'device.time': 'Giờ',
    'device.quick': 'NHANH', 'device.down': 'XUỐNG', 'device.left': 'TRÁI', 'device.right': 'PHẢI',
    'device.rotate': 'XOAY', 'device.reset': 'LẠI(R)', 'device.sound': 'ÂM({key})', 'device.start': 'CHƠI(P)',
    'device.welcome': 'XIN CHÀO', 'device.welcomeLevel': 'Bấm mũi tên để chọn cấp',
    'device.welcomeStart': 'Bấm CHƠI để bắt đầu',
    'device.soundOn': 'Có âm thanh', 'device.soundOff': 'Tắt âm thanh',
    'device.paused': 'Tạm dừng', 'device.playing': 'Đang chơi', 'device.ready': 'Sẵn sàng',
    'leaderboard.aria': 'Bảng xếp hạng {game}', 'leaderboard.heading': '🏆 TOP 10 · MỌI THỜI ĐẠI',
    'leaderboard.reconnecting': 'Đang kết nối lại để cập nhật điểm. Bảng có thể chưa mới nhất.',
    'leaderboard.loading': 'Đang tải bảng xếp hạng…', 'leaderboard.loadError': 'Không thể tải bảng xếp hạng.',
    'leaderboard.networkError': 'Không kết nối được máy chủ để tải bảng xếp hạng.',
    'leaderboard.invalidResponse': 'Dữ liệu bảng xếp hạng không hợp lệ. Vui lòng thử lại.',
    'leaderboard.retry': 'Thử lại', 'leaderboard.empty': 'Chưa có điểm được xác minh.',
    'leaderboard.player': 'Người chơi', 'leaderboard.points': 'Điểm', 'leaderboard.level': 'Cấp {level}',
    'leaderboard.lastRun': 'Ván chơi được xác minh gần nhất của bạn',
    'leaderboard.scoreFormula': '{score} × cấp {level} = {total}',
    'leaderboard.claimed': 'Đã gửi điểm lên bảng xếp hạng.',
    'leaderboard.claimLost': 'Top 10 đã thay đổi trước khi bạn gửi tên. Ván chơi này không còn đủ điều kiện.',
    'leaderboard.notQualified': 'Ván chơi này chưa đạt Top 10 hiện tại.',
    'claim.title': 'Kỷ lục mới',
    'claim.verified': 'Máy chủ đã xác minh {score} × cấp {level} = {total} điểm.',
    'claim.description': 'Nhập tên để nhận vị trí Top 10 trong {game}. Thứ hạng sẽ được kiểm tra lại khi bạn gửi.',
    'claim.playerName': 'Tên người chơi', 'claim.submit': 'Gửi điểm',
    'claim.submitting': 'Đang gửi…', 'claim.skip': 'Bỏ qua',
    'claim.invalidName': 'Dùng 2–20 chữ cái, chữ số, dấu cách, dấu gạch dưới, gạch nối hoặc dấu chấm.',
    'claim.error': 'Không thể gửi tên. Vui lòng thử lại.',
    'run.starting': 'Đang khởi động ván chơi…',
    'run.casualNetwork': 'Không kết nối được máy chủ. Đây là ván chơi thường; điểm không thể vào Top 10.',
    'run.casual': 'Ván chơi thường: chưa thể chơi xếp hạng. Điểm sẽ không vào bảng xếp hạng.',
    'run.ranked': 'Ván xếp hạng: sau khi kết thúc, nếu điểm được xác minh và vào Top 10, biểu mẫu nhập tên sẽ mở.',
    'run.verifying': 'Đã kết thúc. Máy chủ đang xác minh điểm cuối cùng để xét Top 10.',
    'run.qualified': 'Điểm đã xác minh của bạn đạt Top 10. Hãy nhập tên vào biểu mẫu đang mở.',
    'run.boardChanged': 'Top 10 đã thay đổi trước khi bạn gửi tên. Điểm này không còn đủ điều kiện.',
    'run.notEligible': 'Điểm đã được xác minh nhưng chưa đạt Top 10 hiện tại hoặc chưa vượt điểm cũ của bạn. Biểu mẫu nhập tên sẽ không mở.',
    'run.verifyNetworkError': 'Đã kết thúc nhưng không kết nối được máy chủ để xác minh điểm. Điểm không thể vào Top 10.',
    'run.verifyError': 'Đã kết thúc nhưng máy chủ không thể xác minh điểm. Điểm không thể vào Top 10.',
    'run.limit': 'Ván chơi chạm giới hạn 10 phút trước khi kết thúc, nên không có điểm Top 10 được xác minh.',
    'run.skipped': 'Bạn đã bỏ qua biểu mẫu nhập tên, nên điểm đã xác minh không được gửi lên Top 10.',
    'run.claimed': 'Điểm đã xác minh của bạn đã được gửi lên Top 10.',
    'theme.changeDevice': 'Đổi máy chơi', 'theme.eyebrow': 'TÙY CHỈNH THEO Ý BẠN',
    'theme.title': 'Màu máy chơi', 'theme.description': 'Chọn kiểu vỏ máy, rồi điều chỉnh từng màu.',
    'theme.close': 'Đóng tùy chọn màu máy', 'theme.chooseFinish': 'Chọn kiểu máy',
    'theme.fineTune': 'Tinh chỉnh màu sắc',
    'theme.savedLocally': 'Thay đổi xuất hiện ngay trên máy và được lưu trên thiết bị này.',
    'theme.reset': 'Khôi phục Vàng cổ điển',
    'theme.preset.classic-yellow': 'Vàng cổ điển', 'theme.preset.neon-green': 'Xanh neon',
    'theme.preset.ocean-blue': 'Xanh đại dương', 'theme.preset.midnight-black': 'Đen nửa đêm',
    'theme.preset.hot-pink': 'Hồng rực', 'theme.preset.retro-cream': 'Kem hoài cổ E-23',
    'theme.color.case': 'Thân máy', 'theme.color.border': 'Viền máy',
    'theme.color.lcd': 'Màn LCD', 'theme.color.lcdPixel': 'Điểm ảnh LCD',
    'theme.color.lcdBezel': 'Viền màn LCD', 'theme.color.buttonPrimary': 'Nút chính',
    'theme.color.buttonSecondary': 'Nút điều hướng', 'theme.color.label': 'Chữ trên máy',
    'theme.color.accent': 'Màu nhấn', 'theme.color.pageBackground': 'Nền trang',
    'theme.warning.machineText': 'Chữ trên máy có thể khó đọc với màu thân máy này.',
    'theme.warning.lcdPixels': 'Điểm ảnh LCD có thể khó nhìn trên nền màn hình này.',
    'theme.warning.pageText': 'Chữ trên trang có thể khó đọc trên màu nền này.',
  },
  en: {
    'locale.vi': 'Tiếng Việt', 'locale.en': 'English', 'locale.zh-CN': '简体中文',
    'app.brandKicker': 'THE HANDHELD ARCADE', 'app.brandTagline': 'Six classics. One machine.',
    'app.nowPlaying': 'NOW PLAYING', 'app.language': 'Language', 'app.topTenButton': '🏆 Top 10', 'app.hideGuide': 'Hide guide', 'app.showGuide': 'Show guide',
    'app.switchToArrows': 'Switch to arrows', 'app.switchToWasd': 'Switch to WASD',
    'app.wasdMovement': 'WASD movement', 'app.movementAria': 'Movement keyboard controls',
    'app.actionAria': 'Action and system keyboard controls',
    'app.desktopControls1': 'DESKTOP CONTROLS / 01', 'app.desktopControls2': 'DESKTOP CONTROLS / 02',
    'app.moveSelect': 'Move & select', 'app.actionSystem': 'Action & system',
    'app.arrowKeys': 'Arrow keys', 'app.wasdKeys': 'WASD keys',
    'app.wasdMoveHelp': 'WASD moves or steers while playing. On the menu, A/D set speed and W/S set level.',
    'app.arrowMoveHelp': 'Arrow keys move or steer while playing. On the menu, ←/→ set speed and ↑/↓ set level.',
    'app.actionHelp': 'Action / fire / rotate*', 'app.actionFireRotate': 'Action / fire / rotate*', 'app.startPause': 'Start / pause',
    'app.reset': 'Reset', 'app.sound': 'Sound',
    'app.space': 'Space', 'app.spaceHelp': 'Space or X selects the next game on the menu and activates the large action button in play, even when another button has focus. Use Enter for focused toolbar buttons. *Action is used in Tetris, Tank and Shooting.',
    'app.actionHint': 'Space or X selects the next game on the menu and activates the large action button in play, even when another button has focus. Use Enter for focused toolbar buttons. *Action is used in Tetris, Tank and Shooting.',
    'app.topTenTitle': 'Top 10 leaderboard', 'app.closeLeaderboard': 'Close leaderboard',
    'app.mobileGuideButton': 'Guide', 'app.mobileGuideTitle': 'How to play', 'app.closeGuide': 'Close guide',
    'app.mobileGuideMove': 'Use the direction buttons to move. On the menu, left/right sets speed and up/down sets level.',
    'app.mobileGuideAction': 'ROTATE acts, fires or rotates; START begins or pauses; RESET restarts; SOUND toggles audio.',
    'app.mobileGuideGames': 'On the welcome screen, press ROTATE to switch games.',
    'app.mobileGuideDifficulty': 'Difficulty rises automatically with your score. LEVEL and SPEED on the LCD show the current setting.',
    'app.machineAria': 'Brick Game machine',
    'game.tetris': 'TETRIS', 'game.snake': 'SNAKE', 'game.shooting': 'SHOOTING',
    'game.racing': 'RACING', 'game.breakout': 'BREAKOUT', 'game.tank': 'TANK',
    'device.highScore': 'HI-SCORE', 'device.score': 'SCORE', 'device.level': 'LEVEL', 'device.speed': 'SPEED', 'device.time': 'Time',
    'device.quick': 'QUICK', 'device.down': 'DOWN', 'device.left': 'LEFT', 'device.right': 'RIGHT',
    'device.rotate': 'ROTATE DIRECTION', 'device.reset': 'RESET(R)',
    'device.sound': 'SOUND({key})', 'device.start': 'START(P)',
    'device.welcome': 'WELCOME', 'device.welcomeLevel': 'Click the arrows for level',
    'device.welcomeStart': 'Click START to start',
    'device.soundOn': 'Sound on', 'device.soundOff': 'Sound off',
    'device.paused': 'Paused', 'device.playing': 'Playing', 'device.ready': 'Ready',
    'leaderboard.aria': '{game} leaderboard', 'leaderboard.heading': '🏆 TOP 10 · ALL TIME',
    'leaderboard.reconnecting': 'Live updates reconnecting. Scores may be out of date.',
    'leaderboard.loading': 'Loading leaderboards…', 'leaderboard.loadError': 'Could not load leaderboards.',
    'leaderboard.networkError': 'Could not reach the game server to load leaderboards.',
    'leaderboard.invalidResponse': 'Invalid leaderboard data. Please try again.',
    'leaderboard.retry': 'Try again', 'leaderboard.empty': 'No verified scores yet.',
    'leaderboard.player': 'Player', 'leaderboard.points': 'Points', 'leaderboard.level': 'Level {level}',
    'leaderboard.lastRun': 'Your last verified run',
    'leaderboard.scoreFormula': '{score} × level {level} = {total}',
    'leaderboard.claimed': 'Score submitted to the leaderboard.',
    'leaderboard.claimLost': 'The Top 10 changed before your name was submitted. This run no longer qualifies.',
    'leaderboard.notQualified': 'This run did not reach the current Top 10.',
    'claim.title': 'New high score',
    'claim.verified': 'The server verified {score} × level {level} = {total} points.',
    'claim.description': 'Enter a name to claim a Top 10 place in {game}. Your position is checked again when you submit.',
    'claim.playerName': 'Player name', 'claim.submit': 'Claim score',
    'claim.submitting': 'Submitting…', 'claim.skip': 'Skip claim',
    'claim.invalidName': 'Use 2–20 letters, numbers, spaces, underscores, hyphens, or periods.',
    'claim.error': 'Could not submit your name. Please try again.',
    'run.starting': 'Starting game…',
    'run.casualNetwork': 'Could not reach the game server. This is a casual run; its score cannot enter the Top 10.',
    'run.casual': 'Casual run: ranked play is unavailable. This score cannot enter the leaderboard.',
    'run.ranked': 'Ranked run: after game over, a verified Top 10 score will open the player-name form.',
    'run.verifying': 'Game over. The server is verifying your final score for Top 10 eligibility.',
    'run.qualified': 'Your verified score qualifies for Top 10. Enter your name in the open form to claim it.',
    'run.boardChanged': 'The Top 10 changed before your name was submitted. This score no longer qualifies.',
    'run.notEligible': 'Your final score was verified, but it did not qualify for the current Top 10 or improve your existing entry. No name form is shown.',
    'run.verifyNetworkError': 'Game over, but the server could not be reached to verify this score. It cannot enter Top 10.',
    'run.verifyError': 'Game over, but this score could not be verified by the server. It cannot enter Top 10.',
    'run.limit': 'The run reached its 10-minute limit before game over, so there is no verified Top 10 score.',
    'run.skipped': 'You skipped the player-name form, so this verified score was not submitted to Top 10.',
    'run.claimed': 'Your verified score was submitted to Top 10.',
    'theme.changeDevice': 'Change device', 'theme.eyebrow': 'MAKE IT YOURS',
    'theme.title': 'Theme colors', 'theme.description': 'Choose a machine finish, then adjust any color.',
    'theme.close': 'Close theme colors', 'theme.chooseFinish': 'Choose a finish',
    'theme.fineTune': 'Fine-tune the colors',
    'theme.savedLocally': 'Changes appear on the machine immediately and are saved on this device.',
    'theme.reset': 'Reset to Classic Yellow',
    'theme.preset.classic-yellow': 'Classic Yellow', 'theme.preset.neon-green': 'Neon Green',
    'theme.preset.ocean-blue': 'Ocean Blue', 'theme.preset.midnight-black': 'Midnight Black',
    'theme.preset.hot-pink': 'Hot Pink', 'theme.preset.retro-cream': 'Retro Cream E-23',
    'theme.color.case': 'Machine body', 'theme.color.border': 'Machine border',
    'theme.color.lcd': 'LCD screen', 'theme.color.lcdPixel': 'LCD pixels',
    'theme.color.lcdBezel': 'LCD bezel', 'theme.color.buttonPrimary': 'Main button',
    'theme.color.buttonSecondary': 'Direction buttons', 'theme.color.label': 'Machine text',
    'theme.color.accent': 'Accent', 'theme.color.pageBackground': 'Page background',
    'theme.warning.machineText': 'Machine text may be hard to read against the body color.',
    'theme.warning.lcdPixels': 'LCD pixels may be hard to see against the screen color.',
    'theme.warning.pageText': 'Page text may be hard to read against the background color.',
  },
  'zh-CN': {
    'locale.vi': 'Tiếng Việt', 'locale.en': 'English', 'locale.zh-CN': '简体中文',
    'app.brandKicker': '掌上街机', 'app.brandTagline': '六款经典游戏，一台掌机。',
    'app.nowPlaying': '正在游玩', 'app.language': '语言', 'app.topTenButton': '🏆 前十名', 'app.hideGuide': '隐藏指南', 'app.showGuide': '显示指南',
    'app.switchToArrows': '切换方向键', 'app.switchToWasd': '切换 WASD',
    'app.wasdMovement': 'WASD 移动', 'app.movementAria': '移动键盘操作说明',
    'app.actionAria': '动作和系统按键说明',
    'app.desktopControls1': '电脑按键 / 01', 'app.desktopControls2': '电脑按键 / 02',
    'app.moveSelect': '移动与选择', 'app.actionSystem': '动作与系统',
    'app.arrowKeys': '方向键', 'app.wasdKeys': 'WASD 键',
    'app.wasdMoveHelp': '游戏中用 WASD 移动或转向。菜单中 A/D 调速度，W/S 调等级。',
    'app.arrowMoveHelp': '游戏中用方向键移动或转向。菜单中 ←/→ 调速度，↑/↓ 调等级。',
    'app.actionHelp': '动作 / 射击 / 旋转*', 'app.actionFireRotate': '动作 / 射击 / 旋转*', 'app.startPause': '开始 / 暂停',
    'app.reset': '重置', 'app.sound': '声音',
    'app.space': 'Space', 'app.spaceHelp': '菜单中按 Space 或 X 切换游戏；游戏中始终触发大动作键，即使焦点在其他按钮上。按 Enter 操作工具栏按钮。*动作键用于俄罗斯方块、坦克和射击游戏。',
    'app.actionHint': '菜单中按 Space 或 X 切换游戏；游戏中始终触发大动作键，即使焦点在其他按钮上。按 Enter 操作工具栏按钮。*动作键用于俄罗斯方块、坦克和射击游戏。',
    'app.topTenTitle': '前十名排行榜', 'app.closeLeaderboard': '关闭排行榜',
    'app.mobileGuideButton': '指南', 'app.mobileGuideTitle': '玩法指南', 'app.closeGuide': '关闭指南',
    'app.mobileGuideMove': '使用机身方向键移动。菜单中左右键调速度，上下键调等级。',
    'app.mobileGuideAction': '旋转键用于操作、射击或旋转；开始键用于开始或暂停；重置键重新开始；声音键切换音效。',
    'app.mobileGuideGames': '在欢迎界面，按旋转键切换游戏。',
    'app.mobileGuideDifficulty': '难度会随得分自动提高。LCD 上的等级和速度显示当前难度。',
    'app.machineAria': 'Brick Game 掌机',
    'game.tetris': '俄罗斯方块', 'game.snake': '贪吃蛇', 'game.shooting': '射击',
    'game.racing': '赛车', 'game.breakout': '打砖块', 'game.tank': '坦克',
    'device.highScore': '最高分', 'device.score': '得分', 'device.level': '等级', 'device.speed': '速度', 'device.time': '时间',
    'device.quick': '快速', 'device.down': '向下', 'device.left': '向左', 'device.right': '向右',
    'device.rotate': '旋转方向', 'device.reset': '重置(R)',
    'device.sound': '声音({key})', 'device.start': '开始(P)',
    'device.welcome': '欢迎', 'device.welcomeLevel': '按方向键选择等级',
    'device.welcomeStart': '按开始键游玩',
    'device.soundOn': '声音已开启', 'device.soundOff': '声音已关闭',
    'device.paused': '已暂停', 'device.playing': '游戏中', 'device.ready': '准备就绪',
    'leaderboard.aria': '{game} 排行榜', 'leaderboard.heading': '🏆 前十名 · 历史总榜',
    'leaderboard.reconnecting': '正在重新连接实时更新，分数可能不是最新的。',
    'leaderboard.loading': '正在加载排行榜…', 'leaderboard.loadError': '无法加载排行榜。',
    'leaderboard.networkError': '无法连接游戏服务器加载排行榜。',
    'leaderboard.invalidResponse': '排行榜数据无效，请重试。',
    'leaderboard.retry': '重试', 'leaderboard.empty': '暂无经过验证的分数。',
    'leaderboard.player': '玩家', 'leaderboard.points': '分数', 'leaderboard.level': '等级 {level}',
    'leaderboard.lastRun': '您最近验证的一局',
    'leaderboard.scoreFormula': '{score} × 等级 {level} = {total}',
    'leaderboard.claimed': '分数已提交至排行榜。',
    'leaderboard.claimLost': '提交姓名前，前十名已变化，本局不再符合条件。',
    'leaderboard.notQualified': '本局未进入当前前十名。',
    'claim.title': '新高分',
    'claim.verified': '服务器已验证 {score} × 等级 {level} = {total} 分。',
    'claim.description': '输入姓名，争取 {game} 前十名。提交时会再次核实排名。',
    'claim.playerName': '玩家姓名', 'claim.submit': '提交分数',
    'claim.submitting': '提交中…', 'claim.skip': '跳过',
    'claim.invalidName': '请使用 2–20 个字母、数字、空格、下划线、连字符或句点。',
    'claim.error': '无法提交姓名，请重试。',
    'run.starting': '正在启动游戏…',
    'run.casualNetwork': '无法连接游戏服务器。本局为休闲模式，分数无法进入前十名。',
    'run.casual': '休闲模式：排位暂不可用，本局分数不会进入排行榜。',
    'run.ranked': '排位模式：结束后，若验证分数进入前十名，将弹出姓名表单。',
    'run.verifying': '游戏结束。服务器正在验证最终分数是否进入前十名。',
    'run.qualified': '验证分数已进入前十名。请在打开的表单中输入姓名。',
    'run.boardChanged': '提交姓名前，前十名已变化，此分数不再符合条件。',
    'run.notEligible': '最终分数已验证，但未进入当前前十名，也未超过您之前的成绩，因此不会显示姓名表单。',
    'run.verifyNetworkError': '游戏已结束，但无法连接服务器验证分数，因此无法进入前十名。',
    'run.verifyError': '游戏已结束，但服务器无法验证此分数，因此无法进入前十名。',
    'run.limit': '游戏在结束前达到 10 分钟时限，因此没有经过验证的前十名分数。',
    'run.skipped': '您跳过了姓名表单，验证分数未提交至前十名。',
    'run.claimed': '您的验证分数已提交至前十名。',
    'theme.changeDevice': '更换掌机', 'theme.eyebrow': '打造专属风格',
    'theme.title': '掌机配色', 'theme.description': '先选外观，再调整各项颜色。',
    'theme.close': '关闭掌机配色', 'theme.chooseFinish': '选择外观',
    'theme.fineTune': '微调颜色',
    'theme.savedLocally': '更改会立即显示在掌机上，并保存在此设备中。',
    'theme.reset': '恢复经典黄色',
    'theme.preset.classic-yellow': '经典黄色', 'theme.preset.neon-green': '霓虹绿',
    'theme.preset.ocean-blue': '海洋蓝', 'theme.preset.midnight-black': '午夜黑',
    'theme.preset.hot-pink': '亮粉色', 'theme.preset.retro-cream': '复古奶油色 E-23',
    'theme.color.case': '机身', 'theme.color.border': '机身边框',
    'theme.color.lcd': 'LCD 屏幕', 'theme.color.lcdPixel': 'LCD 像素',
    'theme.color.lcdBezel': 'LCD 屏框', 'theme.color.buttonPrimary': '主按钮',
    'theme.color.buttonSecondary': '方向按钮', 'theme.color.label': '机身文字',
    'theme.color.accent': '点缀色', 'theme.color.pageBackground': '页面背景',
    'theme.warning.machineText': '机身文字与机身颜色对比不足，可能难以阅读。',
    'theme.warning.lcdPixels': 'LCD 像素与屏幕颜色对比不足，可能难以看清。',
    'theme.warning.pageText': '页面文字与背景颜色对比不足，可能难以阅读。',
  },
}

export function normalizeLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE
}

export function loadLocale() {
  try {
    return normalizeLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY))
  } catch (_error) {
    return DEFAULT_LOCALE
  }
}

export function saveLocale(locale) {
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, normalizeLocale(locale))
  } catch (_error) {
    // Language switching still works if storage is unavailable.
  }
}

export function translate(locale, key, params = {}) {
  const selected = messages[normalizeLocale(locale)]
  const message = selected[key] || messages[DEFAULT_LOCALE][key] || key
  return message.replace(/\{([a-zA-Z]+)\}/g, (match, name) =>
    Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match)
}

const I18nContext = createContext({ locale: DEFAULT_LOCALE, t: (key, params) => translate(DEFAULT_LOCALE, key, params) })

export function I18nProvider({ locale, children }) {
  const normalized = normalizeLocale(locale)
  return <I18nContext.Provider value={{ locale: normalized, t: (key, params) => translate(normalized, key, params) }}>{children}</I18nContext.Provider>
}

export function useI18n() {
  return useContext(I18nContext)
}
